export const ROUTES = {
  PUBLIC: {
    HOME: '/',
    RESOURCES: '/resources',
    RESOURCE_DETAIL: (slug) => `/resources/${slug}`,
    CAREGIVER_HUB: '/caregiver-hub',
    DIRECTORY: '/directory',
    COMMUNITY: '/community',
    SUBMIT: '/submit',
    SEARCH: '/search',
    ABOUT: '/about',
  },
  VOLUNTEER: {
    DASHBOARD: '/volunteer',
    SUBMISSIONS: '/volunteer/submissions',
    TRANSLATIONS: '/volunteer/translations',
    SAVED: '/volunteer/saved',
    PROFILE: '/volunteer/profile',
  },
  ADMIN: {
    DASHBOARD: '/admin',
    MODERATION: '/admin/moderation',
    CONTENT: '/admin/content',
    TRANSLATIONS: '/admin/translations',
    USERS: '/admin/users',
    DIRECTORY: '/admin/directory',
    ADS: '/admin/ads',
    SETTINGS: '/admin/settings',
  },
  MEDICAL: {
    QUEUE: '/medical-review',
    DETAIL: (id) => `/medical-review/${id}`,
  },
};